// ===== SCROLL REVEAL =====
const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry, i) => {
    if (entry.isIntersecting) {
      setTimeout(() => {
        entry.target.classList.add('revealed');
      }, i * 80);
      revealObserver.unobserve(entry.target);
    }
  });
}, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

document.querySelectorAll('[data-reveal]').forEach(el => revealObserver.observe(el));

// ===== FAQ ACCORDION =====
document.querySelectorAll('.faq-question').forEach(btn => {
  btn.addEventListener('click', () => {
    const item = btn.closest('.faq-item');
    const isOpen = item.classList.contains('open');

    document.querySelectorAll('.faq-item.open').forEach(openItem => {
      openItem.classList.remove('open');
    });

    if (!isOpen) {
      item.classList.add('open');
    }
  });
});

// ===== COUNTDOWN TIMER =====
function startCountdown(targetId, endTime) {
  const el = document.getElementById(targetId);
  if (!el) return;

  function update() {
    const now = new Date().getTime();
    const distance = endTime - now;

    if (distance <= 0) {
      el.innerHTML = '<span class="countdown__expired">Oferta expirada</span>';
      return;
    }

    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    el.querySelectorAll('.countdown__item').forEach((item, i) => {
      const nums = [hours, minutes, seconds];
      item.querySelector('.countdown__number').textContent = String(nums[i]).padStart(2, '0');
    });
  }

  update();
  setInterval(update, 1000);
}

// Initialize countdown: 4 hours from page load
const countdownEl = document.querySelector('[data-countdown]');
if (countdownEl) {
  const hoursFromNow = parseInt(countdownEl.dataset.countdown || '4', 10);
  const endTime = new Date().getTime() + (hoursFromNow * 60 * 60 * 1000);
  startCountdown(countdownEl.id, endTime);
}

// ===== SMOOTH SCROLL FOR CTA BUTTONS =====
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function(e) {
    const target = document.querySelector(this.getAttribute('href'));
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});

// ===== STICKY CTA BAR (mobile only) =====
(function() {
  var bar = document.querySelector('.sticky-cta');
  if (!bar) return;

  var heroVisible = true;
  var footerVisible = false;

  function updateBar() {
    if (!heroVisible && !footerVisible) {
      bar.classList.add('sticky-cta--visible');
    } else {
      bar.classList.remove('sticky-cta--visible');
    }
  }

  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.target.classList.contains('hero')) heroVisible = e.isIntersecting;
      if (e.target.classList.contains('footer')) footerVisible = e.isIntersecting;
      updateBar();
    });
  }, { threshold: 0.05 });

  var heroEl = document.querySelector('.hero');
  var footerEl = document.querySelector('.footer');
  if (heroEl) obs.observe(heroEl);
  if (footerEl) obs.observe(footerEl);
})();
